import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {RedactorUtils} from "../../core/RedactorUtils";
import {Schema} from "@/common/Schema";


export class TriggerTutorial extends TriggerBase {

    constructor() {
        super(TriggerKind.TUTORIAL);
        this._tutorialUID = null;
    }

    get tutorialUID() {
        return this._tutorialUID;
    }

    set tutorialUID(value) {
        this._tutorialUID = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.tutorialUID || !RedactorUtils.getTutorial(this.tutorialUID)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTutorial());
        } else if (target instanceof TriggerTutorial) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerTutorialScope extends TriggerScope {
    static _values = [
        new TriggerTutorialScope(1, "AVAILABLE"),
        new TriggerTutorialScope(2, "ACTIVE"),
        new TriggerTutorialScope(4, "PASSED"),
        new TriggerTutorialScope(3, "CLOSED")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerTutorialScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTutorialScope());
        } else if (target instanceof TriggerTutorialScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerTutorial, {
    _scope: alias("scope", TriggerTutorialScope.schema()),
    _tutorialUID: alias("tutorial_uid", Schema.primitive()),
});